import { yupToFormErrors } from 'formik';

export { getIn, setIn } from 'formik';

export const validateSchema = (values, schema) => {
  try {
    schema.validateSync(values, { abortEarly: false });
  } catch (e) {
    return yupToFormErrors(e);
  }
};

export const omitFormProps = ({
  area,
  form,
  hierarchy,
  active,
  dense,
  initialValue,
  innerRef,
  meta,
  ...props
}) => {
  return props;
};
